import { c as _c } from "react/compiler-runtime";
import { parseDateTime } from "@internationalized/date";
import { getPassengersAndRoomFromQuery } from "@website/accommodation-ui/helpers/passengers";
import { CityType, CityTypeInitialValue } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/auto-complete-input/types";
import { PassengersCountType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/types";
import { TourErrorsType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/types";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { DatepickerCalendarLocaleType, DatepickerSelectedDateType } from "@website/ui/datepicker";
import { daysBetweenDates } from "@website/utils/date-format";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const useValidation = t0 => {
  const $ = _c(19);
  const {
    originItem,
    destinationItem,
    date,
    initialCityFrom,
    initialCityTo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      originError: "",
      destinationError: "",
      dateError: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [errors, setErorrs] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setErorrs(_temp);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== originItem) {
    t3 = [originItem];
    $[2] = originItem;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setErorrs(_temp2);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== destinationItem) {
    t5 = [destinationItem];
    $[5] = destinationItem;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setErorrs(_temp3);
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== date) {
    t7 = [date];
    $[8] = date;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  if ($[10] !== date || $[11] !== destinationItem || $[12] !== initialCityFrom || $[13] !== initialCityTo || $[14] !== originItem) {
    t8 = () => {
      let hasError = false;
      if (!originItem && !initialCityFrom) {
        setErorrs(_temp4);
        hasError = true;
      }
      if (!destinationItem && !initialCityTo) {
        setErorrs(_temp5);
        hasError = true;
      }
      if ((originItem?.iata_code || initialCityFrom?.iata_code) === (destinationItem?.iata_code || initialCityTo?.iata_code)) {
        setErorrs(_temp6);
        hasError = true;
      }
      if (!date || !date?.[0] || !date?.[1]) {
        setErorrs(_temp7);
        hasError = true;
      }
      if (hasError) {
        return false;
      }
      return true;
    };
    $[10] = date;
    $[11] = destinationItem;
    $[12] = initialCityFrom;
    $[13] = initialCityTo;
    $[14] = originItem;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const submitValidationCheck = t8;
  let t9;
  if ($[16] !== errors || $[17] !== submitValidationCheck) {
    t9 = {
      errors,
      submitValidationCheck
    };
    $[16] = errors;
    $[17] = submitValidationCheck;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};

//TODO: Please review
export const useSubmit = (originItem, destinationItem, date, calendarLocale, passengerCount, submitValidationCheck, cityFromInitialValue, cityToInitialValue, isHomePage) => {
  const $ = _c(16);
  const router = useRouter();
  const {
    query,
    pathname
  } = router;
  const searchActionTitle = isHomePage ? "\u062C\u0633\u062A\u062C\u0648" : "\u0628\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u062C\u0633\u062A\u062C\u0648";
  const {
    search_source,
    calendar_type
  } = query;
  let t0;
  if ($[0] !== calendarLocale || $[1] !== calendar_type || $[2] !== cityFromInitialValue?.iata_code || $[3] !== cityToInitialValue?.iata_code || $[4] !== date || $[5] !== destinationItem?.iata_code || $[6] !== originItem?.iata_code || $[7] !== passengerCount || $[8] !== pathname || $[9] !== router || $[10] !== search_source || $[11] !== submitValidationCheck) {
    t0 = () => {
      if (submitValidationCheck()) {
        let startDateTime;
        let endDateTime;
        let startDateObject;
        let endDateObject;
        let startDate;
        let endDate;
        if (date && date?.[0] && date?.[1]) {
          startDateTime = date[0]?.dateTime;
          endDateTime = date[1]?.dateTime;
          startDateObject = parseDateTime(startDateTime);
          endDateObject = parseDateTime(endDateTime);
          startDate = `${startDateObject?.year}-${startDateObject?.month?.toString()?.padStart(2, "0")}-${startDateObject?.day?.toString()?.padStart(2, "0")}`;
          endDate = `${endDateObject?.year}-${endDateObject?.month?.toString()?.padStart(2, "0")}-${endDateObject?.day?.toString()?.padStart(2, "0")}`;
          let passengers = "";
          passengerCount?.map((item, index) => {
            passengers = passengers + `${item?.adult?.length || 1}${item?.child?.length > 0 ? "," : ""}${item?.child?.join(",")}${index < passengerCount?.length - 1 ? "_" : ""}`;
            passengers;
          });
          const parameters = {
            origin: originItem?.iata_code || cityFromInitialValue?.iata_code,
            dest: destinationItem?.iata_code || cityToInitialValue?.iata_code,
            stDate: startDate,
            rtDate: endDate,
            passengers,
            source: "searchBox",
            referrer: "",
            search_source: "search_results_page",
            calendar_type: calendarLocale ? calendarLocale === "gregorian" ? "gregorian" : "jalali" : calendar_type as string
          };
          pathname === "/tour" ? window.location.href = `/tour/${parameters.origin}/${parameters.dest}?${new URLSearchParams(Object.entries(omit(parameters, ["origin", "dest"]))).toString()}` : router.replace({
            pathname,
            query: omit(parameters, "OPEN_SEARCH")
          }, undefined);
          addEventToTracking(USER_TRACKING_EVENTS.GENERAL_SEARCH, {
            product: "tour",
            origin_city: originItem?.iata_code || cityFromInitialValue?.iata_code,
            destination_city: destinationItem?.iata_code || cityToInitialValue?.iata_code,
            departure_date: new Date(startDate),
            return_departure_date: new Date(endDate),
            search_window: Math.abs(daysBetweenDates(new Date(), startDate)),
            number_of_passengers: getPassengersAndRoomFromQuery(passengers as string).adults + getPassengersAndRoomFromQuery(passengers as string).child,
            number_of_rooms: passengerCount?.length,
            search_source: search_source as string,
            calendar_type: calendar_type as string
          });
        }
      }
    };
    $[0] = calendarLocale;
    $[1] = calendar_type;
    $[2] = cityFromInitialValue?.iata_code;
    $[3] = cityToInitialValue?.iata_code;
    $[4] = date;
    $[5] = destinationItem?.iata_code;
    $[6] = originItem?.iata_code;
    $[7] = passengerCount;
    $[8] = pathname;
    $[9] = router;
    $[10] = search_source;
    $[11] = submitValidationCheck;
    $[12] = t0;
  } else {
    t0 = $[12];
  }
  const onSubmitClick = t0;
  let t1;
  if ($[13] !== onSubmitClick || $[14] !== searchActionTitle) {
    t1 = {
      onSubmitClick,
      submitText: searchActionTitle
    };
    $[13] = onSubmitClick;
    $[14] = searchActionTitle;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  return t1;
};
function _temp(previousError) {
  return {
    ...previousError,
    originError: ""
  };
}
function _temp2(previousError_0) {
  return {
    ...previousError_0,
    destinationError: ""
  };
}
function _temp3(previousError_1) {
  return {
    ...previousError_1,
    dateError: ""
  };
}
function _temp4(previousError_2) {
  return {
    ...previousError_2,
    originError: "\u0644\u0637\u0641\u0627 \u0645\u0628\u062F\u0623 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0645\u0627\u06CC\u06CC\u062F"
  };
}
function _temp5(previousError_3) {
  return {
    ...previousError_3,
    destinationError: "\u0644\u0637\u0641\u0627 \u0645\u0642\u0635\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0645\u0627\u06CC\u06CC\u062F"
  };
}
function _temp6(previousError_4) {
  return {
    ...previousError_4,
    destinationError: "\u0645\u0628\u062F\u0623 \u0648 \u0645\u0642\u0635\u062F \u0646\u0645\u06CC \u062A\u0648\u0627\u0646\u0646\u062F \u06CC\u06A9\u0633\u0627\u0646 \u0628\u0627\u0634\u062F"
  };
}
function _temp7(previousError_5) {
  return {
    ...previousError_5,
    dateError: "\u0644\u0637\u0641\u0627 \u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F \u0648 \u062E\u0631\u0648\u062C \u062E\u0648\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0645\u0627\u06CC\u06CC\u062F"
  };
}